import React, { useState, useEffect } from 'react';
import './CookieNotice.css';

function CookieNotice() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Zkontroluj, jestli už uživatel zavřel upozornění
    const cookieNoticeDismissed = localStorage.getItem('cookieNoticeDismissed');
    if (!cookieNoticeDismissed) {
      setIsVisible(true);
    }
  }, []);

  const handleDismiss = () => {
    localStorage.setItem('cookieNoticeDismissed', 'true');
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-notice">
      <div className="cookie-notice-content">
        <p>
          Tato aplikace používá pouze nezbytné cookies pro zabezpečení administrace (session cookies).
          Žádné další cookies ani trackování nepoužíváme.
        </p>
        <button onClick={handleDismiss} className="cookie-notice-button">
          Rozumím
        </button>
      </div>
    </div>
  );
}

export default CookieNotice;
